import { TFiatTicker } from '@types';

export const defaultSettings = {
  fiatCurrency: 'USD' as TFiatTicker,
  darkMode: false,
  dashboardAccounts: [],
  excludedAssets: [],
  language: 'en',
  isDemoMode: false,
  canTrackProductAnalytics: true,
  analyticsUserID: ''
};
